import AbstractProvider from './AbstractProvider'

export default class VimeoProvider extends AbstractProvider {

    constructor(media) {
        super(media)
    }

    init(embedId) {
        return this.initPlayer(new Vimeo.Player(document.getElementById(embedId)))
    }

    script() {
        return 'https://player.vimeo.com/api/player.js'
    }

    setEmbedCode() {
        this.oembed('https://vimeo.com/api/oembed.json')
    }

    ready() {
        return typeof Vimeo !== 'undefined' && this.media.embed.length > 0
    }

}